export const FEATURE_TOGGLE_FEATURE = 'common.feature-toggle';

export interface ToggleResponse {
  toggleIds: string[];
}
